import { useState, useCallback } from "react";
import axios from "axios";
import { api_v3_get_matches_by_player_and_tournament } from "../utils/constants";

export const useMatchData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [matchesByTournament, setMatchesByTournament] = useState({});

  const fetchMatchesByTournament = useCallback(
    async (playerId, tournamentId) => {
      if (!playerId || !tournamentId) return;

      setLoading(true);
      try {
        const url = api_v3_get_matches_by_player_and_tournament(
          playerId,
          tournamentId,
          false
        );
        const response = await axios.get(url);
        if (response.status === 200) {
          const matchesList = response.data.sort(
            (a, b) => a.leagueDay - b.leagueDay
          );
          setMatchesByTournament((prev) => ({
            ...prev,
            [tournamentId]: matchesList,
          }));
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return {
    loading,
    error,
    matchesByTournament,
    fetchMatchesByTournament,
  };
};
